export const MuscleLabelColors: Record<string, string> = {
	latissimus_dorsi: '#9C27B0',
	upper_trapezius: '#9DFF00',
	lower_trapezius: '#9DFF00',
	trapezius: '#0097A7',
	erector_spinae: '#536DFE',
	erector_spinae_core: '#536DFE',
	rhomboids: '#FFD600',
	iliopsoas: '#D500F9',
	iliopsoas_core: '#D500F9',
	iliopsoas_legs: '#D500F9',
	lower_back_muscles: '#651FFF',
	upper_chest: '#FF6E40',
	inner_chest: '#FF8A65',
	pectoralis_major: '#FF7043',
	lower_chest: '#00B0FF',
	biceps_brachii: '#FF1744',
	brachialis: '#FF5252',
	brachioradialis: '#FF8A80',
	triceps_brachii: '#00E676',
	forearm_muscles: '#FFC400',
	deltoid_anterior: '#FF3D00',
	deltoid_posterior: '#6200EA',
	deltoid: '#FFAB00',
	rectus_abdominis: '#00C853',
	obliques: '#795548',
	transversus_abdominis: '#26A69A',
	quadriceps: '#304FFE',
	glutes: '#FF5252',
	hamstrings: '#00BFA5',
	triceps_femoris: '#00BFA5',
	gastrocnemius: '#76FF03',
	soleus: '#64DD17',
	calves: '#9DFF00',
	cardio: '#3F51B5',
	BACK: '#EF7272',
	CHEST: '#C9ACEF',
	ARMS: '#5664FF',
	SHOULDERS: '#E4ECFF',
	ABS: '#FFD861',
	LEGS_GLUTES: '#FA98E5',
	OTHER: '#212121',
}

export const TextColorForBackground: Record<string, string> = {
	'#9C27B0': '#FFFFFF',
	'#0097A7': '#FFFFFF',
	'#536DFE': '#FFFFFF',
	'#FFD600': '#000000',
	'#D500F9': '#FFFFFF',
	'#651FFF': '#FFFFFF',
	'#FF6E40': '#000000',
	'#00B0FF': '#000000',
	'#FF1744': '#FFFFFF',
	'#00E676': '#000000',
	'#FFC400': '#000000',
	'#FF3D00': '#FFFFFF',
	'#6200EA': '#FFFFFF',
	'#FFAB00': '#000000',
	'#00C853': '#000000',
	'#795548': '#FFFFFF',
	'#26A69A': '#000000',
	'#304FFE': '#FFFFFF',
	'#FF5252': '#FFFFFF',
	'#00BFA5': '#000000',
	'#76FF03': '#000000',
	'#3F51B5': '#FFFFFF',
	'#EF7272': '#FFFFFF',
	'#C9ACEF': '#FFFFFF',
	'#5664FF': '#FFFFFF',
	'#E4ECFF': '#000000',
	'#FFD861': '#000000',
	'#FA98E5': '#FFFFFF',
	'#212121': '#FFFFFF',
}
